import React, { useMemo } from 'react';
import styled, {css} from 'styled-components';

import SbEditable from 'components/SbEditableExtended';

import ContentWrapper from 'components/contentWrapper';
import Faq from 'components/blocks/blockPartials/faq';

import calculateBottomSpacingClass from 'components/blocks/utils/calculateBottomSpacingClass';



// Component
const Component = (props) => {

  const spacingBottomClass = useMemo(() => calculateBottomSpacingClass(props.block?.bottom_spacing), [props.block?.bottom_spacing])

  if(!props.block){
    return(<div>Storyblok block missing</div>)
  }

	return(
    <SbEditable content={props.block}>
      <StyledComponent className={`blockFaqs ${spacingBottomClass}`}>
          
        {props.block.content != "" &&
          <ContentWrapper>
              
            {props.block.questions.map((item) => (
              <div className="blockFaqs-faq" key={item['_uid']}>
                <Faq question={item.question} answer={item.answer} />
              </div>
            ))}

          </ContentWrapper>
        }
          
      </StyledComponent>
    </SbEditable>
	);

}

export default Component


// Styles
const StyledComponent = styled.div`

  .blockFaqs-faq{
    margin-bottom: 0.5em;
  }

`